import React, { useState } from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import TermsAndPrivacyModal from './TermsAndPrivacyModal';

const Footer = () => {
  const [termsModalOpen, setTermsModalOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          bgcolor: '#1f2937',
          color: 'white',
          py: 4,
          borderTop: '1px solid rgba(102, 126, 234, 0.2)',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'center',
              alignItems: 'center',
              gap: { xs: 1, sm: 2 },
              mb: 2,
            }}
          >
            <Link
              component="button"
              onClick={() => setTermsModalOpen(true)}
              sx={{
                color: '#9ca3af',
                textDecoration: 'none',
                fontSize: '0.9rem',
                cursor: 'pointer',
                '&:hover': {
                  color: '#667eea',
                  textDecoration: 'underline',
                },
                transition: 'color 0.2s ease',
              }}
            >
              Terms & Conditions
            </Link>
            <Box
              component="span"
              sx={{
                color: '#6b7280',
                display: { xs: 'none', sm: 'inline' },
              }}
            >
              •
            </Box>
            <Link
              component="button"
              onClick={() => setTermsModalOpen(true)}
              sx={{
                color: '#9ca3af',
                textDecoration: 'none',
                fontSize: '0.9rem',
                cursor: 'pointer',
                '&:hover': {
                  color: '#667eea',
                  textDecoration: 'underline',
                },
                transition: 'color 0.2s ease',
              }}
            >
              Privacy Policy
            </Link>
          </Box>
          <Typography
            variant="body2"
            align="center"
            sx={{
              opacity: 0.9,
              fontSize: '0.95rem',
            }}
          >
            © 2025 Stratovai by{' '}
            <Box
              component="span"
              sx={{
                fontWeight: 600,
                color: '#667eea',
              }}
            >
              Kriyanta Labs Pvt Ltd
            </Box>
            . All Rights Reserved.
          </Typography>
        </Container>
      </Box>
      
      <TermsAndPrivacyModal
        open={termsModalOpen}
        onClose={() => setTermsModalOpen(false)}
      />
    </>
  );
};

export default Footer;

